import React, { useState } from 'react';
import { StyleSheet, View, Platform, Switch } from 'react-native';
import { useTheme } from '@emotion/react';
import { ODSIcon } from '../../../atoms/ODSIcon';
import { ODSText } from '../../../atoms/ODSText';
import ODSButton from '../../../atoms/ODSButton';

const RentReadySettingsCard = ({
  onClose,
  data,
  onSave
}) => {
  const { colors } = useTheme();
  const [form, setForm] = useState({
    is_tenant_info_shared: data.is_tenant_info_shared,
    is_right_to_rent_shared: data.is_right_to_rent_shared,
    is_affordability_shared: data.is_affordability_shared,
    is_pre_reference_shared: data.is_pre_reference_shared,
    is_rental_ledger_shared: data.is_rental_ledger_shared,
    is_id_verification_shared: data.is_id_verification_shared,
    is_guarantor_affordability_shared: data.is_guarantor_affordability_shared,
    selectAll: false,
  });


 const handleSwitchChange = (name, value) => {
    if (name === 'selectAll') {
      setForm({
        ...form,
        selectAll: value,
        is_tenant_info_shared: value,
        is_right_to_rent_shared: value,
        is_affordability_shared: value,
        is_pre_reference_shared: value,
        is_rental_ledger_shared: value,
        is_id_verification_shared: value,
        is_guarantor_affordability_shared: value
      });
    } else {
      setForm({
        ...form,
        [name]: value,
        selectAll: false,
      });
    }
  };

  const handleSave = () => {
    onSave(form);
  };

  return (
    <View style={{ flex: 1,...styles.shadowBox }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginBottom: 12 }}>
        <ODSIcon icon={'TB-House'} size={24} color={colors.button.main} />
        <ODSText type='h5' marginLeft={12} color={colors.text.primary}>Rent Ready Settings</ODSText>
      </View>
      <ODSText textAlign='center' type='sm' marginTop={12} color={colors.text.primary}>
      Select the documents to share with your agent.
      </ODSText>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 32 }}>
        <Switch
          value={form.selectAll}
          onValueChange={(value) => handleSwitchChange('selectAll', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Select All</ODSText>
      </View>
      <View style={{width:'100%',marginVertical:24,height:1,backgroundColor:colors.other['border-neutral']}}/>
      

      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 0 }}>
        <Switch
          value={true}
          // disabled={true}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>ID Verification</ODSText>
      </View>
      <ODSText type='sm' marginTop={8} color={colors.text.primary}>You can't unshare a verified ID</ODSText>

      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 24 }}>
        <Switch
          value={form.is_affordability_shared}
          onValueChange={(value) => handleSwitchChange('is_affordability_shared', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Tenant Affordability</ODSText>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 24 }}>
        <Switch
          value={form.is_guarantor_affordability_shared}
          onValueChange={(value) => handleSwitchChange('is_guarantor_affordability_shared', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Guarantor Affordability</ODSText>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 24 }}>
        <Switch
          value={form.is_tenant_info_shared}
          onValueChange={(value) => handleSwitchChange('is_tenant_info_shared', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Tenant Info</ODSText>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 24 }}>
        <Switch
          value={form.is_right_to_rent_shared}
          onValueChange={(value) => handleSwitchChange('is_right_to_rent_shared', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Right to Rent</ODSText>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 24,marginBottom:40 }}>
        <Switch
          value={form.is_pre_reference_shared}
          onValueChange={(value) => handleSwitchChange('is_pre_reference_shared', value)}
        />
        <ODSText type='md' marginLeft={12} color={colors.text.primary}>Rent Ready Reference</ODSText>
      </View>

      <ODSButton onPress={handleSave}>Save</ODSButton>
      <ODSButton onPress={() => onClose()} restStyle={{ marginTop: 12 }} type='secondary'>Close</ODSButton>
    </View>
  );
};

const styles = StyleSheet.create({
  shadowBox: {
    backgroundColor: '#fff',
    marginHorizontal: 20,
    padding: 32,
    borderRadius: 12,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      }
    }),
  },
});

export default RentReadySettingsCard;

